import { msgMenus } from "@/constant/other";
/* 其他路由项 */
const ancestor = "";
const OtherRouter = [
  /* 平台信息 */
  /* menu 可选值 profile  user  privacy law behavior */
  {
    path: "/platform/:menu",
    name: "personal",
    meta: { screen: false, title: "平台信息", ancestor },
    component: () => import("@/views/other/platform/Index.vue"),
  },
  /* 消息中心  */
  {
    path: "/msg/:menu",
    name: "msg",
    meta: { screen: false, title: "消息中心", ancestor },
    component: () => import("@/views/other/msg/Index.vue"),
    beforeEnter: (to, from, next) => {
      const { menu } = to.params;
      const targetMenu = msgMenus.find((it) => it.value === menu);
      if (!targetMenu) return next("/404");
      next();
    },
  },
  {
    path: "/search",
    name: "search",
    /*  */
    meta: { screen: false, title: "搜索", keepAlive: true, ancestor },
    component: () => import("@/views/other/search/Index.vue"),
  },
];
export default OtherRouter;
